export default __webpack_public_path__ + "static/media/022-whistle.3f88667b.svg";